import { mixpanel } from '@fiverr-private/obs';
import { MixpanelEventName, MixpanelEventProperties, MixpanelEventsContext } from './mixpanel.types';
import { MIXPANEL_PROPERTIES_MAP } from './mixpanel.constants';

const mapProps = (props: Partial<MixpanelEventProperties>) =>
    Object.fromEntries(
        Object.entries(props).map(([key, value]) => {
            const formattedKey = MIXPANEL_PROPERTIES_MAP[key] || key;
            return [formattedKey, value];
        })
    );

const createMixpanelReporter = () => {
    let context: MixpanelEventsContext;

    const enrichContext = (
        newContext: MixpanelEventsContext | ((currentContext: MixpanelEventsContext) => MixpanelEventsContext)
    ) => {
        context = { ...context, ...(typeof newContext === 'function' ? newContext(context) : newContext) };
    };

    const send = (name: MixpanelEventName) => {
        mixpanel.track(name, mapProps({ ...context }));
    };

    return {
        enrichContext,
        send,
    };
};

export const globalMixpanelReporter = createMixpanelReporter();
